import type { QueryClient } from '@tanstack/react-query';

/**
 * ENT-5889 (E-05): the react-query keys of every per-user advisory read surface, so a read
 * (page open, CTA visit) or a mutation (create actions) refreshes the index pages and the nav
 * badges at once instead of leaving them stale until their staleTime lapses.
 */
export const ADVISORIES_SHELL_QUERY_KEY = 'advisories-shell';
export const VENDOR_ADVISORIES_SHELL_QUERY_KEY = 'vendor-advisories-shell';
export const MY_ADVISORIES_QUERY_KEY = 'my-advisories';
export const VENDOR_ADVISORIES_QUERY_KEY = 'vendor-advisories';

export function invalidateAdvisoryReadState(queryClient: QueryClient): Promise<void> {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: [ADVISORIES_SHELL_QUERY_KEY] }),
    queryClient.invalidateQueries({ queryKey: [VENDOR_ADVISORIES_SHELL_QUERY_KEY] }),
    queryClient.invalidateQueries({ queryKey: [MY_ADVISORIES_QUERY_KEY] }),
    queryClient.invalidateQueries({ queryKey: [VENDOR_ADVISORIES_QUERY_KEY] }),
  ]).then(() => undefined);
}
